import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper
} from '@tableau/data-catalog-shared';
import * as React from 'react';

import { Messages } from '../../../gen-src/Localize';
import {
  FlowDownstreamDashboardsFilteredByFlowOutputFieldQuery,
  FlowDownstreamDashboardsFilteredByFlowOutputFieldQuery_flows_outputFieldsConnection_nodes_downstreamDashboardsConnection_nodes,
  FlowDownstreamDashboardsFilteredByFlowOutputFieldQueryVariables,

} from '../../../gen-src/queries/FlowDownstreamDashboardsFilteredByFlowOutputFieldQuery';
import {
  FlowDownstreamDashboardsQuery,
  FlowDownstreamDashboardsQuery_flows_downstreamDashboardsConnection_nodes,
  FlowDownstreamDashboardsQueryVariables,
} from '../../../gen-src/queries/FlowDownstreamDashboardsQuery';
import { DashboardSortOrder } from '../../../gen-src/queries/globalTypes';
import {
  FlowDownstreamDashboardsFilteredByFlowOutputFieldQueryGql,
} from '../../queries/FlowDownstreamDashboardsFilteredByFlowOutputFieldQueryGql';
import { FlowDownstreamDashboardsQueryGql } from '../../queries/FlowDownstreamDashboardsQueryGql';
import { DashboardsDisplayGrid, DashboardsDisplayGridRowData, getRowDataForDashboard } from '../sharedDisplayGrid/DashboardsDisplayGrid';
import { DashboardsValidSortFields } from '../sorting/sortProviders/DashboardsGridSortProvider';

type QueryVariables = FlowDownstreamDashboardsQueryVariables;
type QueryResults = FlowDownstreamDashboardsQuery;
type QueryResultListNode = FlowDownstreamDashboardsQuery_flows_downstreamDashboardsConnection_nodes;
type GridRowData = DashboardsDisplayGridRowData;

type QueryVariablesWithFilter = FlowDownstreamDashboardsFilteredByFlowOutputFieldQueryVariables;
type QueryResultsWithFilter = FlowDownstreamDashboardsFilteredByFlowOutputFieldQuery;
type QueryResultListNodeWithFilter =
  FlowDownstreamDashboardsFilteredByFlowOutputFieldQuery_flows_outputFieldsConnection_nodes_downstreamDashboardsConnection_nodes;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  const flow = resultData && resultData.flows && resultData.flows[0];
  return flow ? flow.downstreamDashboardsConnection : null;
}

function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNodeWithFilter> | null {
  const flow = resultData && resultData.flows && resultData.flows[0];
  const flowOutputFields = flow && flow.outputFieldsConnection && flow.outputFieldsConnection.nodes;
  const field = flowOutputFields && flowOutputFields[0];
  return field ? field.downstreamDashboardsConnection : null;
}

export type FlowDownstreamDashboardsQueryGridProps =
  GridSortProps<DashboardsValidSortFields> & {
    readonly flowVizportalUrlId: string;
    readonly filteredFlowOutputFieldId: string | null;
    readonly rowCount: number | null;
  };

export function FlowDownstreamDashboardsQueryGrid(props: FlowDownstreamDashboardsQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamDashboardsLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredDashboardsLineageGridMessage();

  return props.filteredFlowOutputFieldId ? (
    // Query with Selected Field as Filter
    <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
      queryGql={FlowDownstreamDashboardsFilteredByFlowOutputFieldQueryGql}
      partialQueryVariables={{
        flowVizportalUrlId: props.flowVizportalUrlId,
        selectedFlowOutputFieldId: props.filteredFlowOutputFieldId,
        orderBy: props.orderBy as DashboardSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResultForFilteredQuery}
      mapResultNode={getRowDataForDashboard}
    >
      {({ rowStore }) => <DashboardsDisplayGrid
        rowStore={rowStore}
        emptyGridMessage={emptyFilteredGridMessage}
        rowCount={props.rowCount}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder}
      />}
    </PaginatedQueryWrapper>
  ) : (
      // Query without Selection
      <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
        queryGql={FlowDownstreamDashboardsQueryGql}
        partialQueryVariables={{
          flowVizportalUrlId: props.flowVizportalUrlId,
          orderBy: props.orderBy as DashboardSortOrder,
        }}
        selectConnectionListResult={selectConnectionListResult}
        mapResultNode={getRowDataForDashboard}
      >
        {({ rowStore }) => <DashboardsDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />}
      </PaginatedQueryWrapper>
    );
}
